import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Container = styled.div`
  border-radius: 3px;
  overflow: hidden;
  margin-bottom: 18px;
  @media (min-width: 1100px) {
    width: calc(25% - 14px);
    margin-left: 18px;
    &:first-child,
    &:nth-child(4n+1) {
      margin-left: 0;
    }
  }
  @media (min-width: 800px) and (max-width: 1100px) {
    width: calc(33% - 9px);
    margin-left: 17px;
    &:first-child,
    &:nth-child(3n+1) {
      margin-left: 0;
    }
  }
  @media (min-width: 540px) and (max-width: 800px) {
    width: calc(50% - 9px);
    &:nth-child(odd) {
      margin-right: 18px;
    }
  }
  @media (max-width: 540px) {
    width: 100%;
  }
  &:hover {
    box-shadow: 0 2px 20px rgba(0, 0, 0, .33);
    a {
      color: #000;
      .info {
        background: #fff;
      }
    }
  }
  a {
    color: #959595;
    text-decoration: none;
    .img {
      height: 240px;
      background: #fff;
      width: 100%;
      display: block;
      background-size: cover;
      background-position: center;
    }
    .info {
      transition: all 0.3s;
      background: #fff;
      padding: 0 15px;
      height: 50px;
      display: flex;
      align-items: center;
      strong {
        font: italic bold 20px 'Times new roman';
        padding-right: 14px;
        margin-right: 14px;
        &.bar {
          border-right: 1px solid #979797;
        }
      }
    }
  }
`

const Unit = ({imagem_principal, nome, uid, category}) => {
  return (
    <Container>
      <Link to={ `/produto/${uid}`}>
        <span className="img" style={ { backgroundImage: `url(${imagem_principal && imagem_principal.url})` } }></span>
        <span className="info">
          <strong className={ category && 'bar' }>{ nome && nome[0].text }</strong>
          { category && category.nome[0].text }
        </span>
      </Link>
    </Container>
  );
}

export default Unit;
